import { getIndexerRestExplorerApi } from '@shared/service'

const createPagesArray = (totalPages: number): number[] => {
  const pages = []

  for (let i = 1; i < totalPages + 1; i++) {
    pages.push(i)
  }

  return pages
}

export const fetchAllLegacyWHTokenAddresses = async () => {
  const indexerRestExplorerApi = await getIndexerRestExplorerApi()

  const WH_CODE_ID = 5
  const CONTRACT_ADDRESS_LIMIT = 100

  const initialResponse = await indexerRestExplorerApi.fetchContracts({
    codeId: WH_CODE_ID,
    limit: CONTRACT_ADDRESS_LIMIT,
    skip: 0
  })

  const totalPages = Math.ceil(
    initialResponse.paging.total / CONTRACT_ADDRESS_LIMIT
  )

  const pages = createPagesArray(totalPages - 1)

  const allPageResponses = await Promise.all(
    pages.map(async (page) => {
      const response = await indexerRestExplorerApi.fetchContracts({
        codeId: WH_CODE_ID,
        limit: CONTRACT_ADDRESS_LIMIT,
        skip: page * CONTRACT_ADDRESS_LIMIT
      })

      return response.contracts
    })
  )

  const contracts = initialResponse.contracts.concat(...allPageResponses)

  return contracts.map(({ address }) => address)
}
